import { KeyRound, ShieldCheck } from "lucide-react";
import { FormEvent, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiError, api } from "../lib/api";
import { useAuth } from "../lib/auth";

export function Setup() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [form, setForm] = useState({
    setupSecret: "",
    username: "owner",
    displayName: "Owner",
    password: ""
  });
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setSaving(true);
    setError("");
    try {
      await api.setupOwner(form);
      await refresh();
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "สร้าง owner ไม่สำเร็จ");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-panel px-4 py-10">
      <form onSubmit={submit} className="w-full max-w-md rounded border border-line bg-white p-6 shadow-soft">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded bg-brand text-white">
            <ShieldCheck size={24} />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-ink">Setup Owner</h1>
            <p className="text-sm text-slate-500">สร้างบัญชี owner ครั้งแรกด้วย SETUP_SECRET</p>
          </div>
        </div>

        {error ? <div className="mb-4 rounded border border-red-200 bg-red-50 p-3 text-sm text-red-700">{error}</div> : null}

        <label className="mb-4 block">
          <span className="mb-1 block text-sm font-medium text-slate-700">SETUP_SECRET</span>
          <div className="relative">
            <KeyRound className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={16} />
            <input
              type="password"
              value={form.setupSecret}
              onChange={(event) => setForm({ ...form, setupSecret: event.target.value })}
              className="focus-ring w-full rounded border border-line py-2 pl-9 pr-3"
              required
            />
          </div>
        </label>

        <label className="mb-4 block">
          <span className="mb-1 block text-sm font-medium text-slate-700">Username</span>
          <input
            value={form.username}
            onChange={(event) => setForm({ ...form, username: event.target.value })}
            className="focus-ring w-full rounded border border-line px-3 py-2"
            minLength={3}
            required
          />
        </label>

        <label className="mb-4 block">
          <span className="mb-1 block text-sm font-medium text-slate-700">Display name</span>
          <input
            value={form.displayName}
            onChange={(event) => setForm({ ...form, displayName: event.target.value })}
            className="focus-ring w-full rounded border border-line px-3 py-2"
            required
          />
        </label>

        <label className="mb-6 block">
          <span className="mb-1 block text-sm font-medium text-slate-700">Password</span>
          <input
            type="password"
            value={form.password}
            onChange={(event) => setForm({ ...form, password: event.target.value })}
            className="focus-ring w-full rounded border border-line px-3 py-2"
            minLength={10}
            required
          />
        </label>

        <button
          type="submit"
          disabled={saving}
          className="w-full rounded bg-brand px-4 py-2.5 font-semibold text-white transition hover:bg-teal-800 disabled:cursor-not-allowed disabled:opacity-60"
        >
          {saving ? "Creating..." : "Create Owner"}
        </button>
      </form>
    </div>
  );
}
